export default function LocationsSkeleton() {
  return (
    <div className="divide-y divide-gray-300 px-2">
      {Array.from({ length: 3 }).map((_, index) => (
        <div
          key={`location-skeleton-${index}`}
          className="animate-pulse py-4 first:pt-0 last:pb-0"
        >
          <div className="mb-2 h-5 w-3/4 rounded bg-gray-200"></div>
          <div className="space-y-1">
            <div className="h-4 w-full rounded bg-gray-200"></div>
            <div className="h-4 w-2/3 rounded bg-gray-200"></div>
          </div>
        </div>
      ))}
    </div>
  );
}
